export const RICHTER_FRENZEL_ORGANISATION_IDS: string[] = [
  // STG
  "df15704b-3eef-4c4f-8c5c-6670a2bcf6b0",
  // PARTNER
  "499562e1-bd69-4623-a110-1da6042375d4",
  "03000e61-ba6b-4085-97a0-0813344c342e",
  "c41dd987-d589-4899-8a9c-86ebe23da039",
  "c24df88c-631a-4950-828b-c786f58db98b",
  // PROD
  "2e821242-abe0-4b4c-97b1-d7f950b8fa77",
];

export const RICHTER_FRENZEL_LOCALE_OVERRIDES: Record<string, string> = {
  de: "de-RF",
};
